import React from 'react'
import { useTranslation } from 'react-i18next'
import './privacy.styles.scss'

const Cookies = () => {
    const { t } = useTranslation();

    return (
        <div className='privacy' aria-label="Informativa sui cookie">
            <h2 className='title'>{t("cookies.title")}</h2>
            <p className='subtitle'>{t("cookies.p1")}</p>
            <p className='paragraph'>{t("cookies.p1.p")}</p>
            <p className='subtitle'>{t("cookies.p2")}</p>
            <p className='paragraph'>{t("cookies.p2.p1")}</p>
            <ul aria-label="Elenco tipologie cookie">
                <li><p className='paragraph'>{t("cookies.p2.p2")}</p></li>
                <li><p className='paragraph'>{t("cookies.p2.p3")}</p></li>
            </ul>
            <p className='paragraph'>{t("cookies.p2.p4")}</p>
            <p className='subtitle'>{t("cookies.p3")}</p>
            <p className='paragraph'>{t("cookies.p3.p")}</p>
            <p className='subtitle'>{t("cookies.ex")}</p>
            <a className='link' href={t("cookies.link1")} target="_blank" rel="noopener noreferrer" aria-label="Link esterno alla fonte dell'esempio">{t("cookies.link1")}</a>
            <p className='subtitle'>{t("cookies.ch")}</p>
            <a className='link' href={t("cookies.link2")} target="_blank" rel="noopener noreferrer" aria-label="Link per la gestione dei cookie su Chrome">{t("cookies.link2")}</a>
            <p className='subtitle'>{t("cookies.sa")}</p>
            <a className='link' href={t("cookies.link3")} target="_blank" rel="noopener noreferrer" aria-label="Link per la gestione dei cookie su Safari">{t("cookies.link3")}</a>
            <p className='subtitle'>{t("cookies.mo")}</p>
            <a className='link' href={t("cookies.link4")} target="_blank" rel="noopener noreferrer" aria-label="Link per la gestione dei cookie su Mozilla Firefox">{t("cookies.link4")}</a>
            <p className='paragraph'>{t("cookies.p4")}</p>
        </div>
    )
}

export default Cookies